import { PrimaryButton } from "../ButtonPrimary";
import { SecundaryButton } from "../ButtonSecundary";
import { useModal } from "../../../hooks";

type TEliminarProps = {
  name: String;
  handleDeletion: Function;
  urlTittle?: string;
  isLoading?: boolean;
};

export default function EliminarModal({
  name,
  handleDeletion,
  urlTittle,
  isLoading
}: TEliminarProps) {
  const { closeModal } = useModal();

  return (
    <div className="max-w-full mx-auto">
      <div className="w-full flex justify-center">
        <svg
          width="48"
          height="48"
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.4 10.8H41.6L38.124 42.084C38.0048 43.1606 37.4927 44.1555 36.6858 44.878C35.8788 45.6006 34.8336 46.0001 33.7504 46H14.2496C13.1664 46.0001 12.1212 45.6006 11.3142 44.878C10.5073 44.1555 9.99515 43.1606 9.876 42.084L6.4 10.8ZM13.759 4.5234C14.1149 3.76873 14.678 3.13079 15.3826 2.684C16.0873 2.23721 16.9044 1.99999 17.7388 2H30.2612C31.0959 1.99957 31.9136 2.2366 32.6187 2.68342C33.3237 3.13023 33.8872 3.76839 34.2432 4.5234L37.2 10.8H10.8L13.759 4.5234ZM28.4 21.8V32.8V21.8Z"
            fill="#FBF3F2"
          />
          <path
            d="M2 10.8H46M19.6 21.8V32.8M28.4 21.8V32.8M6.4 10.8H41.6L38.124 42.084C38.0048 43.1606 37.4927 44.1555 36.6858 44.878C35.8788 45.6006 34.8336 46.0001 33.7504 46H14.2496C13.1664 46.0001 12.1212 45.6006 11.3142 44.878C10.5073 44.1555 9.99515 43.1606 9.876 42.084L6.4 10.8ZM13.759 4.5234C14.1149 3.76873 14.678 3.13079 15.3826 2.684C16.0873 2.23721 16.9044 1.99999 17.7388 2H30.2612C31.0959 1.99957 31.9136 2.2366 32.6187 2.68342C33.3237 3.13023 33.8872 3.76839 34.2432 4.5234L37.2 10.8H10.8L13.759 4.5234Z"
            stroke="#E1726F"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
      <h1 className="w-full text-xl text-center font-bold mx-auto my-5">
        ¿Seguro que deseas eliminar el registro?
      </h1>
      <p className="text-center font-normal text-lav-black-text mt-10">
        Esta acción no podrá deshacerse.
      </p>
      <div className="flex my-10">
        <SecundaryButton
          type="submit"
          text="Cancelar"
          onClick={() => urlTittle && closeModal(urlTittle)}
          styles="border-red-400 font-bold mr-3 text-red-400 hover:bg-opacity-10 hover:bg-red-400 hover:text-red-400"
        />
        <PrimaryButton
          type="submit"
          text="Eliminar"
          styles="bg-red-400 text-white font-bold hover:bg-red-500"
          disabled={isLoading}
          onClick={() => handleDeletion()}

        />
      </div>
    </div>
  );
}
